

import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@app/_modules/translate';
import { AppPipes } from '@app/_pipes';
import { ButtonComponent } from '@app/components/button/button.component';

@Component({
    selector: 'text-truncate-toggler',
    templateUrl: './text-truncate-toggler.template.html',
    styleUrls: ['./text-truncate-toggler.styles.scss'],
    imports: [AppPipes, ButtonComponent, TranslateModule]
})
export class TextTruncateTogglerComponent implements OnInit {
  @Input() input: string;
  @Input() limit: number;
  public expanded = false;
  public toggleButton = false;

  ngOnInit(): void {
    this.toggleButton = this.inputOverLimit();
  }

  private inputOverLimit(): boolean {
    return this.input?.length > this.limit;
  }

  public toggle(): void {
    this.expanded = !this.expanded;
  }
}
